import { render, staticRenderFns } from "./FBMOrder.vue?vue&type=template&id=061021c2&scoped=true&"
import script from "./FBMOrder.vue?vue&type=script&lang=js&"
export * from "./FBMOrder.vue?vue&type=script&lang=js&"
import style0 from "./FBMOrder.vue?vue&type=style&index=0&id=061021c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061021c2",
  null
  
)

export default component.exports